import {
    POST,
    postFile,
    GET
} from "../../index";
export const selectExternal = (param) => POST("/v1/external/selectExternal", param);
export const insertExternal = (param) => POST("/v1/external/insertExternal", param);
export const updateExternal = (param) => POST("/v1/external/updateExternal", param);
export const deleteExternal = (param) => POST("/v1/external/deleteExternal", param);
export const externalBindingCar = (param) => POST("/v1/external/externalBindingCar", param);
